import React from 'react';
import BottomNavigation from '@m2h/components/BottomNavigation';
import './index.css';

interface M2hContianerProps {
  children: any;
  contentStyle?: any;
}

const M2hContianer: React.FC<M2hContianerProps> = ({ children, contentStyle }: M2hContianerProps) => {
  console.log('M2hContianer');

  return (
    <view className="m2h-container">
      <view className="m2h-children-container" style={{ ...contentStyle }}>
        {children}
      </view>
      <BottomNavigation />
    </view>
  );
};

export default M2hContianer;
